import { AsseticChip } from '@assetic/web-components';
import { Box, TextField, Typography, Grid } from '@mui/material';
import React, { CSSProperties } from 'react';
import { Link } from 'react-router-dom';
import { Subscription, SubscriptionType } from 'types/models';
import { ChipColorMap } from '../UserPage';
import { IconTextBadge } from 'app/components/IconTextBadge';
import fonts from 'app/assets/styles/fonts';
import { UsageCountChip } from 'app/components/UsageCountChip';
import { UrlToSubscription } from 'app/constants';
import {
  CustomerSubTypeIcon,
  InternalSubTypeIcon,
} from 'app/components/Icons/Subscriptionicons';
import { NestedCssProperties } from 'styles/makeThemeStyle';
import LabelBox from '../../components/LabelBox';

const Label = ({ children }) => (
  <Box color="text.secondary">
    <Typography variant="subtitle2">{children}</Typography>
  </Box>
);

//TODO: Extract to a component
export const UserType = (props: { subscription_type?: SubscriptionType }) => {
  const smallVariantStyle: NestedCssProperties<CSSProperties> = {
    fontSize: fonts.small,
  };
  switch (props.subscription_type) {
    case 'internal':
      return (
        <IconTextBadge
          icon={<InternalSubTypeIcon />}
          text="Internal"
          iconStyle={smallVariantStyle}
          textStyle={smallVariantStyle}
          wrapperStyle={{ padding: '0 4px' }}
        />
      );
    case 'customer':
    default:
      return (
        <IconTextBadge
          icon={<CustomerSubTypeIcon />}
          iconStyle={smallVariantStyle}
          textStyle={smallVariantStyle}
          wrapperStyle={{ padding: '0 4px' }}
          text="Customer"
        />
      );
  }
};

export const SubscriptionInfo: React.FC<Subscription> = props => {
  const {
    status = '',
    subscription_id = '',
    plan_name = '',
    subscription_type,
    data_region_label = '',
    expiry_date = '',
    portfolio_limit = 0,
    portfolio_usage = 0,
  } = props;

  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  };

  const dateObj = Date.parse(expiry_date);

  const formattedExpiryDate = dateObj
    ? new Intl.DateTimeFormat('en-AU', options).format(dateObj)
    : '--Not Set--';

  const UrlToSubDetail = UrlToSubscription(subscription_id).detail;

  return (
    <Grid container spacing={2}>
      <Grid item lg={4} xs={12}>
        <LabelBox>
          <Label>Subscription Status</Label>
          <AsseticChip label={status} color={ChipColorMap(status)} uppercase />
        </LabelBox>
        <LabelBox>
          <Label>Subscription Type</Label>
          <Box mt={0.5}>
            <UserType subscription_type={subscription_type} />
          </Box>
        </LabelBox>

        <LabelBox>
          <Label>Subscription ID</Label>
          <Link to={UrlToSubDetail}>{subscription_id}</Link>
        </LabelBox>
      </Grid>
      <Grid item lg={4} xs={12}>
        <LabelBox>
          <TextField
            label="Plan Type"
            variant="outlined"
            value={plan_name}
            disabled
            fullWidth
          />
        </LabelBox>
        <LabelBox>
          <TextField
            label="Data Region"
            variant="outlined"
            value={data_region_label}
            disabled
            fullWidth
          />
        </LabelBox>
        <LabelBox>
          <TextField
            label="Expiry"
            variant="outlined"
            value={formattedExpiryDate}
            disabled
            fullWidth
          />
        </LabelBox>
      </Grid>

      <Grid item lg={4} xs={12}>
        <LabelBox>
          <Label>Portfolio Usage</Label>
          <UsageCountChip usage={portfolio_usage} limit={portfolio_limit} />
        </LabelBox>
      </Grid>
    </Grid>
  );
};
